import React, { useMemo } from 'react';
import {
    DocumentPreviewProvider,
    DossierDocumentsProvider,
    DossierFormulaireProvider,
    DossierRoutingProvider,
    dossiersBasePath,
    FormalitiesProvider,
    FormulairesProvider,
    Layout,
    LAYOUT_DEFAULT,
    LAYOUT_DOCUMENTS,
    LAYOUT_DOCUMENTS_1_3,
    LAYOUT_DOCUMENTS_FULL,
    LAYOUT_FORMS_FULL,
    TypeDocumentsProvider,
    useCurrentDossierCtx,
    useDefaultContextActions,
} from '@europrocurement/l2d-modules';
import { useDumbActionsContext } from '@europrocurement/flexy-components';
import { DossierInfoBodyValidation } from '../../components';

import { ordersBasePath } from '../../../Orders';

const getLayout = (): Layout => {
    const layouts = [
        LAYOUT_DEFAULT,
        LAYOUT_DOCUMENTS,
        LAYOUT_DOCUMENTS_FULL,
        LAYOUT_DOCUMENTS_1_3,
        LAYOUT_FORMS_FULL,
    ];
    const params = new URLSearchParams(document.location.search);

    if (params.has('layout') && layouts.includes(params.get('layout') as string)) {
        return params.get('layout') as Layout;
    }

    return LAYOUT_DEFAULT;
};

const DossierInfoValidation: React.FunctionComponent = function () {
    const layout = getLayout();
    const { dossier, siblings } = useCurrentDossierCtx();

    const siblingIds = useMemo(
        () => (siblings ? siblings.map((sibling) => sibling.id) : []),
        [siblings],
    );
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    if (!dossier) {
        return null;
    }

    return (
        <FormalitiesProvider autoload>
            <FormulairesProvider autoload>
                <DossierRoutingProvider
                    orderBasePath={ordersBasePath}
                    dossierBasePath={dossiersBasePath}
                >
                    <DossierFormulaireProvider idDossiers={siblingIds as number[]}>
                        <TypeDocumentsProvider autoload>
                            <DossierDocumentsProvider
                                autoload
                                dossierIds={siblingIds as number[]}
                            >
                                <DocumentPreviewProvider>
                                    <DossierInfoBodyValidation layout={layout} />
                                </DocumentPreviewProvider>
                            </DossierDocumentsProvider>
                        </TypeDocumentsProvider>
                    </DossierFormulaireProvider>
                </DossierRoutingProvider>
            </FormulairesProvider>
        </FormalitiesProvider>
    );
};

export default DossierInfoValidation;
